import { Layout, message } from 'antd';
import React , {useEffect,useState }from 'react'
import './list.css';
import './layui.css';
import {getJudgeCaseList,getConfig} from './service';
import {getCatch,doLogout} from '../../utils/auth';

import JSZip from "jszip";
import { saveAs } from 'file-saver';
import $ from 'jquery'

import axios from 'axios';

const { Header, Content, Footer } = Layout;
const scrheight = document.body.clientHeight;
const scrwidth = document.body.clientWidth;

let autorunning = false;


const List = props => { 
  const [LOGO, setLogoElements] = useState(''); 


  const LOGINNAME = getCatch("name");
 
  // 页面初始化
  useEffect(() => {
    dogetConfig();
    getOpList();
  }, []);

  //自动更新列表信息
  const autorun = async() => {
    if(!autorunning){
      autorunning = true;
      setInterval(function(){
        getOpList();
        console.log(1);
      }, 5000);
    }
  }
  const dogetConfig = async() => {
    var param = {"f":"J_getConfig","p":{}};
    return await getConfig(param).then((res) => {
      console.log(res);
      if(res.c != 0){
        var url = '../../img/TopDigitalLogo.png';
      }
      else{
        var url = res.d.config.judgelogo;
      }
      setLogoElements([...LOGO, url]);

    })
  }
  
  const getOpList = async () =>{
    var param = {"f":"J_caseList","p":{"token":getCatch("token")}};
    getJudgeCaseList(param).then((res) => {
      if(res.c !== 0){
        message.error(res.m);
      }
      else{
        let ele = document.getElementById("list");
        let html = '<ul style="padding: 0px!important">';
        html += '<li style="height: 40px">';
        html += '<span style="width:20%;height: 40px;line-height:40px;">参赛组别</span>';
        if(getCatch("level") == 3){
          html += '<span style="width:35%;height:40px;line-height:40px;">作品名称</span>';
        }
        else{
          html += '<span style="width:45%;height:40px;line-height:40px;">作品名称</span>';
        }
        html += '<span style="height: 40px;line-height: 40px; width:10%">我的打分</span>';
        if(getCatch("level") == 3){
          html += '<span style="height: 40px;line-height:40px; width:10%">平均分</span>';
        }
        html += '<span style="height: 40px;line-height:40px; width:10%">是否打分</span>';
        html += '<span style="height: 40px;line-height:40px; width:10%">打分机会</span>';
        html += '</li>';
        for(let i = 0;i < res.d.list.length;i++){
          html += '<a href="javascript:window.open(\'./#/detail?id='+res.d.list[i].id+'\',\'_blank\');">';
          html += '<li>'; 
          html += '<span style="width:20%;text-align:left;margin-left:5px;overflow:hidden;">'+res.d.list[i].categoryname+'</span>';
          if(getCatch("level") == 3){
            html += '<span style="width:35%;overflow:hidden;">'+res.d.list[i].name+'</span>';
          }
          else{
            html += '<span style="width:45%;overflow:hidden;">'+res.d.list[i].name+'</span>';
          }
          html += '<span style="width:10%">'+res.d.list[i].myscore+'</span>';
          if(getCatch("level") == 3){
            html += '<span style="width:10%">'+res.d.list[i].avg+'</span>';
          }
          html += '<span style="width:10%">'+(res.d.list[i].scorecnt > 0 ? "<img src='../../img/right.png' style='height:25px;width:25px;'>" : "")+'</span>';
          html += '<span style="width:10%">'+(2 - res.d.list[i].scorecnt)+'</span>';
          html += '</li>';
          html += '</a>';
        }
        html += '</ul>';

        ele.innerHTML = html;
        
        autorun();
      }
    })
  }
  
  // const download = (()=>async function(){
  //   let fileList = [
  //     {"name":"caseradar_11708.doc","id":11708},
  //     {"name":"caseradar_11731.doc","id":11731},
  //     {"name":"caseradar_11733.doc","id":11733}
  //   ];
  //   try {
  //     const url = "https://wxapp.kuaipantech.com/TopDigital/index.php";
  //     const zip = new JSZip(); // 创建一个新的JSZip对象

  //     // 异步下载每个文件并添加到zip中
  //     for (const file of fileList) {
  //       // 使用axios以blob格式下载文件
  //       const response = await axios.post(file.url, {"f":"A_downloadradard","p":{"id":file.id}});
  //       console.log(response);
  //       // 将下载的blob转换为JSZip可以处理的Uint8Array
  //       zip.file(file.name, response.data);
  //     }

  //     // 生成ZIP文件的blob对象
  //     const content = await zip.generateAsync({ type: 'blob' });
  //     // 使用file-saver触发文件下载
  //     saveAs(content, 'radar.zip');
  //   } catch (error) {
  //     console.error('批量下载失败:', error);
  //   } finally {
      
  //   }
  // })

  return (
    <Layout className="layout"> 
    <Header>
      <div style={{width:"90%",marginLeft:"5%"}}>
        {/* <div onClick={download()}>下载</div> */}
        <div style={{float:'left', width:"50%"}}>
        <div className="logo" ><img src={LOGO} alt="" width="120px" /></div>
        </div>
        <div style={{float:'right',color:"#afa178"}}>
        {LOGINNAME} / <a href='#' onClick={doLogout} ><span style={{color: "#afa178"}}>退出登录</span></a> / <a href='./#/list'><span style={{color: "#afa178"}}>返回首页</span></a>
        </div>
      </div>
    </Header>
    <Content
      style={{
        padding: '30px 50px 10px',
        // background: "#a4080f"
        background: "#9864C9"
      }}
    >
      {/* <div style={{textAlign:"center",width: "100%",height:"120px",opacity:"0.4",marginTop:"-20px",backgroundPositionY:"top",backgroundSize:"20%"}}>
        <img src={[require("../../img/logo-04.png")]} alt="" style={{height:"90%"}} />
      </div> */}
      <div className="site-layout-content" style={{minHeight:scrheight-200,width:'90%',marginLeft:"5%"}}>

      <div style={{width:'90%',marginLeft:'5%'}}>
        <h4 className="hh" style={{fontWeight:"200",fontSize:"15px"}}>{LOGINNAME}，您好，欢迎为下面的作品打分！</h4> 
        <div style={{margin: "0 auto",marginBottom: "50px"}}></div>
        {/*<h4 className="hh" style={{fontWeight:"200",fontSize:"15px"}}>请开始为参赛作品打分</h4>*/}
        <div className="list" id="list">
            
        </div>
      </div>

    </div>
    </Content>

    <Footer style={{clear:"both",backgroundColor: "white",paddingTop: "20px",height: "115px"}}>
    {/* <p className="copyright">联系方式:021-61150705、021-61150706</p>
    <p className="copyright">case2019@topdigitalworld.com</p> */}
    <p className="copyright">Copyright © 上海优天网络科技有限公司</p>
    </Footer>
  </Layout>

  );
}
export default List;